
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import HeaderBlueprint from './header';
import MapBlueprint from './../map/main';
import ActiveFilterBlueprint from './../map/filter';
import ListBlueprint from './../list/main';
import {extend, cloneObject, stringify, getHash} from './../../zviz2/zviz/functions';
import {styleText, styleHeader2, styleWords} from './../../styles';
import config from './../../config';
//import {LifeCycle} from './../zviz2/zviz/cycle';


class MainController extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

    }


    getChildren(){

        let view = state.get('view');
        if(view == 'list'){
            return [cloneObject(ListBlueprint)];
        }else{
            return [extend({
                        properties: { 
                            data: { dimensions: ['region', 'country']}}
                    }, ActiveFilterBlueprint), 
                    extend({
                        properties: { 
                            data: { dimensions: ['theme_category', 'theme']}}
                    }, ActiveFilterBlueprint),
                    cloneObject(MapBlueprint)];
        }
    }

    getMessage(){
        return [];
    }

    getError(){
        let error = state.get('errorMessage');
        if(error){
            return extend({
                properties: {
                    data: {
                        title: error.title || error.toString(),
                        description: error.description || null
                    }
                }
            }, BlueprintError);
        }

        return [];
    }

}

let BlueprintError = extend({
    properties: {
        style: {
            position: 'fixed',
            top: '0px',
            left: '0px',
            bottom: '0px',
            right: '0px',
            backgroundColor: 'rgba(255,255,255,0.4)',
            zIndex: 5
        },
        data: {
            title: 'An unknown error occured',
            description: 'There is no additional information about this error available'
        }
    },
    children: [
        extend({
            properties: {
                style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '300px',
                    height: '180px',
                    marginLeft: '-160px',
                    marginTop: '-100px',
                    backgroundColor: 'white',
                    padding: '10px',
                    textAlign: 'center',
                    border: '2px solid rgb(107, 145, 203)'
                }
            },
            children: [
                extend({ 
                    properties: {
                        style: extend({
                            display: 'block',
                            position: 'absolute',
                            bottom: '20px',
                            left: '50%',
                            height: '28px',
                            width: '40px',
                            lineHeight: '28px',
                            fontSize: '10pt',
                            marginTop: '10px',
                            marginLeft: '-35px',
                            color: 'white',
                            padding: '0px 12px 0px 30px',
                            backgroundColor: '#FA3C4B',
                            backgroundImage: 'url(\'' + config.imgPath + 'delete_filter.png\')',
                            backgroundPosition: '5px center',
                            backgroundRepeat: 'no-repeat'
                        }, styleWords),
                        content: 'Close'
                    },
                    events: {
                        click: (event, ctrl) => { state.set('errorMessage', null); },
                    }
                }, Link),

                extend({
                    properties: {
                        style: extend({
                            fontSize: '14pt'
                        }, styleHeader2),
                        content: (ctrl) => ( ctrl.parent.parent.data.title )
                    }
                }, Group),

                extend({
                    properties: {
                        style: extend({

                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.parent.data.description )
                    }
                }, Group)
            ]
        }, Group)
    ]
}, Group);

let Blueprint = extend({
    type: MainController,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'view')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'errorMessage')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source'))
    ],
    properties: {
        style: {
            position: 'static',
            float: (ctrl) => ( (state.get('renderSize') == 'large')? 'right': 'none'),
            width: (ctrl) => ( (state.get('renderSize') == 'large')? '70%': '100%'),
            marginTop: '35px'
            // left: '30%',
            // top: '0px'
        }
    },
    events: {  },
    children: [
        cloneObject(HeaderBlueprint),

        extend({
            properties: {
                style: {
                    position: 'relative'
                },
                data: {
                    view: () => (state.get('view'))
                }
            },
            children: [ 
                (ctrl) => ( ctrl.parent.getChildren() ) 
            ]
        }, Group),

        (ctrl) => ( ctrl.getError() ),
        (ctrl) => ( ctrl.getMessage() ),
    ]
}, Group);

export default Blueprint;
export {Blueprint};
